import axios from '../axios';

// Actions
export const LOAD_VEHICLE_MODEL_LIST_SUCCESS = 'LOAD_VEHICLE_MODEL_LIST_SUCCESS';
export const LOAD_VEHICLE_MODEL_LIST_FAILED = 'LOAD_VEHICLE_MODEL_LIST_FAILED';

// Reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case LOAD_VEHICLE_MODEL_LIST_SUCCESS:
      return {
        ...state,
        all: action.data,
        error: '',
      };
    case LOAD_VEHICLE_MODEL_LIST_FAILED:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

// Action Creators
export const loadVehicleModelListSuccess = (data) => {
  return {
    type: LOAD_VEHICLE_MODEL_LIST_SUCCESS,
    data,
  };
};
export const loadVehicleModelListFailed = (error) => {
  return {
    type: LOAD_VEHICLE_MODEL_LIST_FAILED,
    error,
  };
};

export const loadVehicleModelList = () => {
  return (dispatch) => {
    axios
      .get('/vehiclemodels', { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } })
      .then((response) => {
        dispatch(loadVehicleModelListSuccess(response.data));
      })
      .catch((error) => {
        dispatch(loadVehicleModelListFailed(error));
      });
  };
};
